import { render, staticRenderFns } from "./myReporting.vue?vue&type=template&id=2fff1daa&"
import script from "./myReporting.vue?vue&type=script&lang=js&"
export * from "./myReporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports